export default {
  en: {
    locationResultCardInfoPhone: 'Phone',
    locationResultCardInfoSelectLocation: 'Select Location',
    technicalErrorMessage: 'Technical difficulties, please try again later.',
    timeSlotAvailability: 'left'
  },
  es: {
    locationResultCardInfoPhone: 'Teléfono',
    locationResultCardInfoSelectLocation: 'Seleccionar Ubicación',
    technicalErrorMessage: 'Dificultades técnicas, inténtelo de nuevo más tarde.',
    timeSlotAvailability: 'disponible'
  }
};
